import actions from "./actions";

const initState = {
  loading: false,
  message: null,
  buttonLoading: false,
  error: null,
  incentiveData: {},
  totalData: null,
  servicelist: [],
  totalVoucher:[],
  show: false,
};

export default function incentiveReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_INCENTIVE_DATA:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_INCENTIVE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        incentiveData: action.payload.data,
        totalData: action.payload.totalDat,
      };
    case actions.GET_INCENTIVE_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
      case actions.GET_VOUCHERS_DATA:
        return {
          ...state,
          loading: true,
        };
      case actions.GET_VOUCHERS_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          totalVoucher: action.payload.totalVoucher,
        };
      case actions.GET_VOUCHERS_DATA_FAILED:
        return {
          ...state,
          loading: false,
          error: action.payload.error,
        };
      
      case actions.OPEN_INCENTIVE_FORM:
      return {
        ...state,
        show: true,
      };

    case actions.INCENTIVE_RESET:
      return {
        ...state,
        show: false,
      };
 
    case actions.DELETE_INCENTIVE:
      return {
        ...state,
        buttonLoading: true,
      };
    case actions.DELETE_INCENTIVE_SUCCESS:
      return {
        ...state,
        buttonLoading: false,
        message: "Incentive deactive successfully",
      };
    case actions.DELETE_INCENTIVE_FAILED:
      return {
        ...state,
        buttonLoading: false,
        show: false,
        error: action.payload.error,
      };

    case actions.INCENTIVE_RESET_MESSAGE:
      return {
        ...state,
        loading: false,
        message: null,
        error: null,
        show: false,
      };

      case actions.GET_SERVICES:
        return {
          ...state,
        };
      case actions.GET_SERVICES_SUCCESS:
        return {
          ...state,
          loading: false,
          servicelist: action.servicelist.payload.categories,
        };
      case actions.GET_SERVICES_FAILED:
        return {
          ...state,
          loading: false,
          error: action.payload.error,
        };


        case actions.ADD_INCENTIVE:
          return {
            ...state,
            buttonLoading: true,
          };
        case actions.ADD_INCENTIVE_SUCCESS:
          return {
            ...state,
            show: false,
            buttonLoading: false,
            message: 'Incentive added successfully'
          };
        case actions.ADD_INCENTIVE_FAILED:
          return {
            ...state,
            buttonLoading: false,
            show: false,
            error: action.payload.error,
          };

          case actions.EDIT_INCENTIVE:
            return {
              ...state,
              buttonLoading: true,
            };
          case actions.EDIT_INCENTIVE_SUCCESS:
            return {
              ...state,
              buttonLoading: false,
              show: false,
              message: 'Incentive Update successfully'
            };
          case actions.EDIT_INCENTIVE_FAILED:
            return {
              ...state,
              buttonLoading: false,
              show: false,
              error: action.payload.error,
            };
    
   
    default:
      return state;
  }
}
